import { Box } from '@chakra-ui/react';
import React from 'react';
import MyProgressBar from '../custom-components/progress-bar/MyProgressBar';
import LogoutButton from '../custom-components/buttons/LogoutButton';

const StepperContainer = ({ left, progressValue, isShowProgress, children }) => {
    return (
        <>
            {isShowProgress && (
                <Box>
                    <MyProgressBar left={left} value={progressValue} />
                </Box>
            )}

            {children}
            <LogoutButton variant='desktop' />
        </>
    );
};

export default StepperContainer;
